import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PoWidgetModule, PoTagModule, PoContainerModule } from '@po-ui/ng-components';
import { InventoryLastCountedModel } from '../../../../../models/inventory-last-counted.model';

@Component({
  selector: 'app-inventory-count-detail-last-counted-card',
  imports: [PoWidgetModule, PoTagModule, CommonModule,PoContainerModule],
  templateUrl: './inventory-count-detail-last-counted-card.component.html',
  styleUrl: './inventory-count-detail-last-counted-card.component.css'
})
export class InventoryCountDetailLastCountedCardComponent {
  @Input() lastCountedList: InventoryLastCountedModel[] = [];
}
